<app-course-accreditation-inspection-preview-shared></app-course-accreditation-inspection-preview-shared>
